import { Button, buttonVariants } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import Header from '@/components/ui/header';
import { TERMS_AND_CONDITIONS } from '@/lib/config';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Helmet } from '@dr.pogodin/react-helmet';
import { cn } from '@/lib/utils.ts';
import Footer from '@/components/ui/footer';
import { useEffect, useState } from 'react';
import Loading from '@/components/common/loading.tsx';
import { getPromoBySlug } from '@/lib/promos';

export const Route = createFileRoute('/_checkAuth/promos/$promoSlug')({
  component: RouteComponent,
});

function RouteComponent() {
  const { promoSlug } = Route.useParams();
  const [termsChecked, setTermsChecked] = useState(false);

  const promo = getPromoBySlug(promoSlug);

  // If we finish loading and the promo is not found, redirect to the home page
  useEffect(() => {
    if (!promo) {
      window.location.replace('/');
    }
  }, [promo]);

  if (!promo) {
    return <Loading />;
  }

  return (
    <>
      <Helmet>
        <title>{promo.title} | MovieClub</title>
      </Helmet>
      <Header className="z-50" />
      <main className="sm:site-container z-0">
        <section className="mx-5 pb-10 sm:m-0">
          <Card className="overflow-hidden rounded-sm border bg-background shadow-xs">
            <img src={promo.banner} alt={promo.title} className="h-auto w-full" />

            <div className="p-5 pb-16 sm:p-10">
              <h2 className="text-2xl font-bold text-primary">¡Disfrutá de estos beneficios ahora!</h2>
              {promo.copy && <h6>{promo.copy}</h6>}

              <div>
                {promo.benefits.map((item, index) => (
                  <div key={index} className="mb-2 flex flex-col first:mt-5 [&>p]:text-sm">
                    <p className="text-lg! font-bold text-primary">{item.title}</p>
                    {item.description}
                  </div>
                ))}
                <p className="pt-5 text-sm text-muted-foreground">Descuentos aplicable en la tarifa vigente.</p>
              </div>

              <h2 className="mb-2 mt-5 text-xl font-bold text-secondary-hover">
                ¡Asociate ahora! Entrá a tu nuevo Club y salí al Cine
              </h2>

              <div className="my-5 h-px w-full bg-border opacity-50"></div>

              <Link to={TERMS_AND_CONDITIONS} target="_blank" rel="noopener noreferrer" preload={false}>
                <Button className="p-0 text-sm" variant="link">
                  Ver Términos y Condiciones
                </Button>
              </Link>

              <div className="flex items-center gap-2">
                <Checkbox checked={termsChecked} id="terms" onClick={() => setTermsChecked(!termsChecked)} />
                <label htmlFor="terms"> estoy de acuerdo con los términos y condiciones</label>
              </div>

              <div className="mt-5">
                <Link
                  className={cn(
                    'w-full lg:max-w-60',
                    buttonVariants({
                      variant: 'default',
                      radius: 'full',
                    }),
                    {
                      'cursor-pointer': termsChecked,
                      'bg-primary/60!': !termsChecked,
                    },
                  )}
                  to="/registro"
                  search={{ redirect: `/asociate?club_id=${promo.clubId}` }}
                  preload={false}
                  disabled={!termsChecked}
                >
                  ¡Asociarme!
                </Link>
              </div>

              {!!promo.notes && promo.notes.length > 0 && (
                <div className="mt-10 flex flex-col gap-1 text-sm text-muted-foreground">
                  {promo.notes.map((note, index) => (
                    <p key={index}>{note}</p>
                  ))}
                </div>
              )}
            </div>
          </Card>
        </section>
      </main>
      <Footer />
    </>
  );
}
